









































































































































import {
  studentLeaveType,
  classLessonList,
  leaveAdd,
  leaveAddData,
} from "@/api/rollCallRecord";
import { searchStudent, autoSearchData } from "@/api/globalSearch";
import { Component, Prop, Vue } from "vue-property-decorator";
import OSSImageUploader from "@/components/ossImageUploader.vue";
@Component({
  name: "leaceAppliDetails",
  components: {
    OSSImageUploader,
  },
})
export default class extends Vue {
  searchInfo: any = {
    start_time: "",
    end_time: "",
    student_id: "",
    images: [],
    expireTimeClass: [],
  };
  leave_type = [];
  studentName = "";
  expireTimeClass = "";
  LessonList = [];
  rules = {
    student_id: [{ required: true, message: "请选择学员", trigger: "change" }],
    leave_type: [
      { required: true, message: "请选择请假类型", trigger: "change" },
    ],
    expireTimeClass: [
      { required: true, message: "请选择请假时间", trigger: "change" },
    ],
  };
  created() {
    const _t = this as any;
    _t.getstudentLeaveType();
    _t.globalSearch("", "student");
    const route = this.$route.query;
    if (route.from === "storeTable") {
      this.searchInfo.student_id = Number(route.sid);
      this.searchInfo.leave_type = Number(route.type);
      this.searchInfo.expireTimeClass[0] = `${route.year} ${route.s_time}`;
      this.searchInfo.expireTimeClass[1] = `${route.year} ${route.e_time}`;
      const s_t: any = new Date(this.searchInfo.expireTimeClass[0]);
      const e_t: any = new Date(this.searchInfo.expireTimeClass[1]);
      this.searchInfo.start_time = Date.parse(s_t) / 1000;
      this.searchInfo.end_time = Date.parse(e_t) / 1000;
      this.datechooseClass([s_t, e_t]);
    }
  }
  setCoverS(res: any) {
    const _t = this as any;
    _t.searchInfo.images.push(res.data.object);
  }
  delImg(res: any) {
    const _t = this as any;
    _t.searchInfo.images.splice(res, 1);
  }
  getclassLessonList(data: {
    start_time: number;
    end_time: number;
    student_id: number;
  }) {
    const _t = this as any;
    if (_t.searchInfo.student_id != "") {
      data.student_id = _t.searchInfo.student_id;
    }
    if (_t.searchInfo.start_time != "") {
      data.start_time = _t.searchInfo.start_time;
    }
    if (_t.searchInfo.end_time != "") {
      data.end_time = _t.searchInfo.end_time;
    }
    classLessonList(data).then((res: any) => {
      if (res.error_code == 0) {
        if (res.data.list != null) {
          res.data.list.forEach((a: any) => {
            switch (Number(a.class_lesson_week_day)) {
              case 1:
                a.class_lesson_week_day = "一";
                break;
              case 2:
                a.class_lesson_week_day = "二";
                break;
              case 3:
                a.class_lesson_week_day = "三";
                break;
              case 4:
                a.class_lesson_week_day = "四";
                break;
              case 5:
                a.class_lesson_week_day = "五";
                break;
              case 6:
                a.class_lesson_week_day = "六";
                break;
              case 0:
                a.class_lesson_week_day = "日";
                break;
            }
          });
        }
        _t.LessonList = res.data.list;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  postData() {
    const _t = this as any;
    _t.$refs["form"].validate((valid: any) => {
      if (valid) {
        if (_t.searchInfo.expireTimeClass) {
          delete _t.searchInfo.expireTimeClass;
        }
        leaveAdd(_t.searchInfo).then((res: any) => {
          if (res.error_code == 0) {
            _t.$message({
              type: "success",
              message: "提交成功!",
            });
            _t.searchInfo = {
              start_time: "",
              end_time: "",
              student_id: "",
              cause: "",
              images: [],
              expireTimeClass: "",
            };
            _t.goBack();
          } else {
            _t.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      } else {
        return false;
      }
    });
  }
  datechooseClass(e: Date[]) {
    const _t = this as any;
    let expire_start_time: number | String = "";
    let expire_end_time: number | String = "";
    if (e != null) {
      const timeone: any = new Date(e[0]);
      const timetwo: any = new Date(e[1]);
      expire_start_time = (timeone * 1000) / 1000000;
      expire_end_time = (timetwo * 1000) / 1000000;
      _t.searchInfo.start_time = expire_start_time;
      _t.searchInfo.end_time = expire_end_time;
      if (_t.searchInfo.student_id != "") {
        _t.getclassLessonList({
          student_id: _t.searchInfo.student_id,
          start_time: _t.searchInfo.start_time,
          end_time: _t.searchInfo.end_time,
        });
      }
    }
  }
  chooseStudent() {
    const _t = this as any;
    if (_t.searchInfo.student_id) {
      if (_t.searchInfo.start_time && _t.searchInfo.end_time) {
        _t.getclassLessonList({
          student_id: _t.searchInfo.student_id,
          start_time: _t.searchInfo.start_time,
          end_time: _t.searchInfo.end_time,
        });
      }
    }
  }
  getstudentLeaveType() {
    const _t = this as any;
    studentLeaveType().then((res: any) => {
      if (res.error_code == 0) {
        _t.leave_type = res.data.list;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  goBack() {
    this.$router.go(-1);
  }
  // 通用搜索框
  getglobalsearchdata(data: autoSearchData, type: String) {
    if (type == "student") {
      data.status = [2];
      return searchStudent(data);
    }
  }
  async globalSearch(queryString: string, type: string) {
    const _t = this;
    let data: autoSearchData = {
      page: 1,
      page_size: 100,
    };
    let restaurants: any = {};
    if (queryString) {
      data = {
        page: 1,
        page_size: 10,
      };
      if (type == "class") {
        data.name = queryString;
      } else if (type == "course") {
        data.title = queryString;
      } else if (type == "student") {
        data.key_word = queryString;
      } else {
        data.key_word = queryString;
      }
    }
    restaurants = await _t.getglobalsearchdata(data, type);
    const list = restaurants.data.list;
    if (type == "student") {
      _t.studentName = list;
    }
  }
}
